import { CASHFLOW_CONTENT_BY_ID } from "./cashflowMoneySafety.js";
import { GENERATED_CONTENT_BY_ID } from "./generatedContent.js";

/** Merged overrides — cashflow batch wins on id collision. */
export const DICTIONARY_CONTENT_BY_ID = {
  ...GENERATED_CONTENT_BY_ID,
  ...CASHFLOW_CONTENT_BY_ID,
};

export function getDictionaryContentForTerm(termId) {
  return DICTIONARY_CONTENT_BY_ID[termId] || null;
}
